var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.58 0H1.42C.64 0 0 .63 0 1.4v6.2C0 8.36.64 9 1.42 9h11.16C13.36 9 14 8.37 14 7.6V1.4c0-.77-.64-1.4-1.42-1.4zm-.24 1L7.22 4.15a.41.41 0 0 1-.44 0L1.66 1h10.68zm.24 7H1.42A.4.4 0 0 1 1 7.6V1.76L6.25 5a1.42 1.42 0 0 0 1.5 0l5.24-3.23V7.6a.4.4 0 0 1-.4.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default ForwardRef;